import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface SimulationToContractData {
  clienteId: string;
  clienteCnpj: string;
  linhasRenovacao: Array<{
    numeroLinha: string;
    planId: string;
  }>;
  linhasAditivo: Array<{
    ddd: string;
    numero: string;
    planId: string;
    iccid?: string;
    fastchip?: boolean;
    seraUsadaPeloCliente: boolean;
  }>;
  linhasParaSuspender?: string[]; // Números das linhas marcadas para suspender (numeroLinha)
  credenciaisMeuTim?: {
    login: string;
    senha: string;
  };
}

interface SimulationToContractContextType {
  simulationData: SimulationToContractData | null;
  openContractModalWithSimulation: (data: SimulationToContractData) => void;
  clearSimulationData: () => void;
}

const SimulationToContractContext = createContext<SimulationToContractContextType | undefined>(undefined);

export const SimulationToContractProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [simulationData, setSimulationData] = useState<SimulationToContractData | null>(null);

  const openContractModalWithSimulation = (data: SimulationToContractData) => {
    setSimulationData(data);
  };

  const clearSimulationData = () => {
    setSimulationData(null);
  };

  return (
    <SimulationToContractContext.Provider
      value={{
        simulationData,
        openContractModalWithSimulation,
        clearSimulationData,
      }}
    >
      {children}
    </SimulationToContractContext.Provider>
  );
};

export const useSimulationToContract = () => {
  const context = useContext(SimulationToContractContext);
  if (context === undefined) {
    throw new Error('useSimulationToContract must be used within a SimulationToContractProvider');
  }
  return context;
};
